import { render, staticRenderFns } from "./DrawerUserView.vue?vue&type=template&id=5b7bb725&"
import script from "./DrawerUserView.vue?vue&type=script&lang=js&"
export * from "./DrawerUserView.vue?vue&type=script&lang=js&"
import style0 from "./DrawerUserView.vue?vue&type=style&index=0&id=5b7bb725&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports